module.exports = __webpack_public_path__ + "static/media/emailkod.4ea090ef.svg";